export default __webpack_public_path__ + "static/media/onboarding-aside.496044b2.png";